import {Button, Col, Form, Row} from "antd";
import {RangePickerProps} from "antd/es/date-picker";
import {pharmacyStoreService} from "api";
import {InputFields, Notification} from "components/common";
import {exportFile, formatDateToString} from "helper/common";

const {INPUT, SELECT, DATE_DISABLE, COMBO_BOX} = FIELD_TYPE;
import React, {useEffect, useState} from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
const ModalExport = props => {
  const {closeModal} = props;
  const [form] = Form.useForm();
  const fieldsInit: any[] = [
    {
      type: DATE_DISABLE,
      name: "start",
      label: "Từ ngày",
      rules: [{required: true, message: "Chưa chọn ngày bắt đầu"}],
    },
    {
      type: DATE_DISABLE,
      name: "end",
      label: "Đến ngày",
      rules: [{required: true, message: "Chưa chọn ngày kết thúc"}],
    },
  ];
  const [fields, setFields] = useState(fieldsInit);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("end");
      if (endDay) {
        return currentDate >= endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("start");
      if (start) {
        return currentDate <= start;
      }
    };
    fieldsInit.find(e => e.name == "start").disabledDate = disabledDateStart;
    fieldsInit.find(e => e.name == "end").disabledDate = disabledDateEnd;
    setFields([...fieldsInit]);
  }, []);
  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      const params = {
        start: formatDateToString(values?.start, FORMAT_TIME.dayFull),
        end: formatDateToString(values?.end, FORMAT_TIME.dayFull),
      };
      await exportFile(
        "store/receipt/export-bao-cao-quy",
        params,
        `Báo cáo xuất nhập tồn từ ${formatDateToString(
          values?.start,
          FORMAT_TIME.dayFull
        )} đến ${formatDateToString(values?.end, FORMAT_TIME.dayFull)}`
      );
    } catch (error) {
      Notification(
        "error",
        error?.response?.data ?? "Đã có lỗi khi xuất báo cáo"
      );
    }
  };
  return (
    <div>
      <Form form={form}>
        <Row gutter={[4, 4]}>
          <InputFields data={fields}></InputFields>
          <Col>
            {" "}
            <Button type="primary" onClick={onSubmit}>
              Xuất báo cáo
            </Button>
          </Col>
        </Row>
        <Row justify={"end"}></Row>
      </Form>
    </div>
  );
};
export default ModalExport;
